
export default function HasPricesMixin(modelName = 'model') {
    return {
        computed: {

            hasMultipleActivePrices() {
                return this.activePrices.length > 1;
            },

            activePrices() {
                return this[modelName] && this[modelName].prices && this[modelName].prices.length ? this[modelName].prices.filter(price => price.is_active && !price.for_additional) : [];
            },

            lowestActivePrice() {
                return this.activePrices.length ? this.activePrices.sort((a,b) => a.cents < b.cents ? -1 : 1)[0] : null
            },

            lowestNextPrice() {
                if (!this[modelName] || !this[modelName].prices || !this[modelName].prices.length) {
                    return null;
                }

                const nextPrices = this[modelName].prices.filter(price => {
                    // We only want main prices
                    if (price.for_additional) {
                        return false;
                    }

                    if (!this.lowestActivePrice) {
                        return price.start_date && this.$date(price.start_date).isAfter();
                    }

                    return price.cents > this.lowestActivePrice.cents;
                });
                if (!nextPrices || !nextPrices.length) {
                    return null;
                }

                return nextPrices.sort((a,b) => a.cents < b.cents ? -1 : 1)[0]
            },

            // The price to currently display to the user. Should be the current active price but might be the next price, when the active price does not exist
            displayPrice() {
                const price = this.lowestActivePrice ? this.lowestActivePrice : this.lowestNextPrice;
                if (price) {
                    return price;
                }

                // We use the latest price as fallback
                const prices = this[modelName].prices && this[modelName].prices.length ? [...this[modelName].prices] : [];
                return prices && prices.length ? prices.sort((a,b) => {
                    if (a.end_date !== b.end_date) {
                        if (!a.end_date) {
                            return -1;
                        }
                        if (!b.end_date) {
                            return 1;
                        }

                        return a.end_date > b.end_date ? -1 : 1
                    }

                    return a.cents < b.cents ? -1 : 1
                })[0] : null
            }
        }
    }
}